<template>
  <div>
    <h3 class="mb-5">Compatible Products</h3>
    <div class="h4 mb-5">
      ADATA | XPG 未使用 <br>
      描述顯示於產品頁，若要新增兼容產品數量，請點擊下方 [添加Compatible Product] 按鈕
    </div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in product.compatible" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Compatible Product {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- Slogan -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">Title</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input
                type="text"
                placeholder="請輸入 Title"
                v-model="item.title"
              />
            </div>
            <div class="h5 ink-02-medium--text text-right mt-1">0/10</div>
          </div>
        </label>

        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">圖片</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸: <br/>
              ADATA: 未使用 <br />
              XPG: 未使用 <br/>
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.image"
              dir="product"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- 添加Company Culture -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Compatible Product</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        image: '',
      };
      this.product.compatible.push(template);
    },
    deleteItem(item) {
      const index = this.product.compatible.map((i) => i.id).indexOf(item.id);
      this.product.compatible.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.product.compatible.length - 1) {
        this.product.compatible.splice(i, 1);
        this.product.compatible.unshift(item);
        return;
      }
      // item become next index
      this.product.compatible.splice(i, 1);
      this.product.compatible.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.product.compatible.splice(i, 1);
        this.product.compatible.push(item);
        return;
      }
      // item become previous index
      this.product.compatible.splice(i, 1);
      this.product.compatible.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
